import { render, staticRenderFns } from "./MainQuestPanel.vue?vue&type=template&id=6d78a9b4&"
import script from "./MainQuestPanel.vue?vue&type=script&lang=ts&"
export * from "./MainQuestPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports